import { render, staticRenderFns } from "./CustomFieldColumn.vue?vue&type=template&id=2f2d39a5&scoped=true"
import script from "./CustomFieldColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldColumn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d39a5",
  null
  
)

export default component.exports